import React from "react";
import { Button } from "./button";

type Props = {
	total: number;
	limit: number;
	offset: number;
	onChange: (nextOffset: number) => void;
};

export function Pagination({ total, limit, offset, onChange }: Props) {
	const page = Math.floor(offset / limit) + 1;
	const totalPages = Math.max(1, Math.ceil(total / limit));
	const canPrev = offset > 0;
	const canNext = offset + limit < total;
	return (
		<div className="flex items-center justify-between mt-4">
			<div className="text-sm text-[var(--color-muted)]">
				Page {page} of {totalPages}
			</div>
			<div className="flex gap-2">
				<Button
					disabled={!canPrev}
					onClick={() => canPrev && onChange(offset - limit)}
				>
					Previous
				</Button>
				<Button
					disabled={!canNext}
					onClick={() => canNext && onChange(offset + limit)}
				>
					Next
				</Button>
			</div>
		</div>
	);
}
